// ===== Packages =====

import styled                       from 'styled-components';

// ===== Constants =====

import {
    CURSOR_Z_INDEX,
    CART_ICON_CONTAINER_PADDING_MULTIPLIER,
    CART_ICON_MARGIN_MULTIPLIER,
    BODY_FONT_SIZE,
    NAVBAR_MARGIN_TOP_MULTIPLIER,
}                                   from '../../constants/generalConstants';
import FONT_TYPE                    from '../../constants/fontType';

interface ContainerProps {
    lightBackground?: boolean,
    showLightBackground?: boolean,
    customCursorActive: boolean,
}
export const Container = styled.div<ContainerProps>`
    position: fixed;
    top: ${`${NAVBAR_MARGIN_TOP_MULTIPLIER}em`};
    right: 0;
    z-index: ${CURSOR_Z_INDEX - 2};
    padding: ${`${0.15625 * BODY_FONT_SIZE}px`};
    margin-right: ${`${CART_ICON_MARGIN_MULTIPLIER}em`};
    background: ${({ lightBackground, showLightBackground, theme }) => (lightBackground && showLightBackground
        ? theme.color.white
        : 'transparent'
    )};
    border-radius: ${`${1.25 * BODY_FONT_SIZE}px`};
    cursor: ${({ customCursorActive }) => (customCursorActive ? 'default' : 'pointer')};
`;

interface CartIconContainerProps {
    dark?: boolean,
    showLightBackground?: boolean,
    length: number,
    detectTouchDevice: boolean,
}
export const CartIconContainer = styled.div<CartIconContainerProps>`
    width: ${({ length }) => `${length + 2 * CART_ICON_CONTAINER_PADDING_MULTIPLIER * BODY_FONT_SIZE}px`};
    height: ${({ length }) => `${length + 2 * CART_ICON_CONTAINER_PADDING_MULTIPLIER * BODY_FONT_SIZE}px`};
    border-radius: ${({ length }) => `${(length + 2 * CART_ICON_CONTAINER_PADDING_MULTIPLIER * BODY_FONT_SIZE) / 2}px`};
    padding: ${`${CART_ICON_CONTAINER_PADDING_MULTIPLIER * BODY_FONT_SIZE}px`};
    background: ${({ dark, showLightBackground, theme }) => (dark && showLightBackground
        ? theme.color.white
        : 'transparent'
    )};

    & div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }
    
    & svg {
        width: 100%;
        height: 100%;
        overflow: visible;
    }

    & path, & rect {
        fill: ${({ theme, dark }) => (dark
        ? theme.verascopeColor.purple200
        : theme.color.white
    )};
        transform: scale(1);
        transform-origin: 50% 50% 0;
    }

    &:hover path, &:hover rect {
        ${({ detectTouchDevice, theme }) => (!detectTouchDevice && `
            fill: ${theme.verascopeColor.yellow200};
            transform: scale(1.5);
        `)}
    }
`;

interface CartBadgeProps {
    count: number,
    transitionDuration: number,
}
export const CartBadge = styled.div<CartBadgeProps>`
    position: absolute;
    top: ${`${-0.0625 * BODY_FONT_SIZE}px`};
    right: ${`${-0.1875 * BODY_FONT_SIZE}px`};
    padding: ${`${0.25 * BODY_FONT_SIZE}px`};
    padding-right: ${`${0.15625 * BODY_FONT_SIZE}px`};
    padding-bottom: ${`${0.15625 * BODY_FONT_SIZE}px`};
    font-family: ${FONT_TYPE.PRESS_START};
    font-weight: 500;
    font-size: 0.7em;
    color: ${({ theme }) => theme.verascopeColor.white};
    background: ${({ theme }) => theme.verascopeColor.red200};
    --cartItemCounter: ${({ count }) => count};
    counter-reset: cartItemCounter var(--cartItemCounter);
    pointer-events: none;
    transition: ${({ transitionDuration }) => `--cartItemCounter ${transitionDuration}ms`};

    &::after {
        content: counter(cartItemCounter);
    }
`;
